import { useRef, useState } from "react";
import api from "../lib/api";
import { Mic, Square, Sparkles } from "lucide-react";
import { toast } from "sonner";

// Tarayıcı ses dikte (ücretsiz, sağlayıcı gerektirmez) + yapay zekâ ile metin düzeltme (anahtar girilmişse)
export default function NoteAssist({ value, onChange, kind = "servis notu", testid = "note-assist" }) {
  const [on, setOn] = useState(false); const [busy, setBusy] = useState(false); const rec = useRef(null);
  const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
  const toggle = () => {
    if (!SR) return toast.error("Bu tarayıcı sesle yazmayı desteklemiyor (Chrome/Edge/Safari deneyin)");
    if (on) { rec.current?.stop(); return; }
    const r = new SR(); r.lang = "tr-TR"; r.interimResults = false; r.continuous = true;
    let base = value || "";
    r.onresult = (e) => { let t = ""; for (let i = e.resultIndex; i < e.results.length; i++) if (e.results[i].isFinal) t += e.results[i][0].transcript + " "; if (t) { base = (base ? base.replace(/\s*$/, " ") : "") + t.trim(); onChange(base); } };
    r.onerror = () => setOn(false); r.onend = () => setOn(false);
    rec.current = r; r.start(); setOn(true);
  };
  const polish = async () => {
    if (!(value || "").trim()) return;
    setBusy(true);
    try { const { data } = await api.post("/ai/polish", { text: value, kind }); onChange(data.text); toast.success("Metin düzeltildi"); }
    catch (e) { const d = e.response?.data?.detail; toast.error(typeof d === "string" ? d : "Düzeltilemedi"); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex gap-2 mt-1" data-testid={testid}>
      <button type="button" onClick={toggle} data-testid="voice-btn" className={`text-xs inline-flex items-center gap-1 px-2 py-1 rounded border ${on ? "bg-rose-50 border-rose-300 text-rose-700" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>{on ? <><Square className="h-3 w-3" />Durdur</> : <><Mic className="h-3 w-3" />Sesle yaz</>}</button>
      <button type="button" onClick={polish} disabled={busy} data-testid="polish-btn" className="text-xs inline-flex items-center gap-1 px-2 py-1 rounded border border-slate-200 text-slate-600 hover:bg-slate-50"><Sparkles className="h-3 w-3" />{busy ? "Düzeltiliyor…" : "AI ile düzelt"}</button>
    </div>
  );
}
